module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/dLuURm/images/cover.jpg?1695727802112",
      "alt": "This image is the cover for the book Salvation Collection"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Salvation Collection\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("I am documenting my journey, an inspired poem at a time, from baby steps to a wonderous understanding of the precepts of my salvation. I truly pray that the poetry will guide your understanding of God's grace and promise of eternal salvation. The miracle of knowing that this journey is with your family for all time brings joy beyond description. The poems are not scripture but a documentation of the truth surrounding my soul with grace and love. Using my poetry as a path by following my footsteps will help you to your salvation. My environmental work has spanned the globe and has saved and enhanced many thousands of lives, which uniquely prepared me to convey my journey in a way for you to understand and hopefully emulate.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Bill Stokes\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("For most of my life I have used poetry to document my life. Life is the ultimate roller coaster; you have little or no control over as to what gets thrown at you, but you have absolute control over how you respond.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Publication Consultants\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0